import { CLEAR_MESSAGES, SET_MESSAGE } from "./actionTypes";

export const setMessage = (message) => ({
  type: SET_MESSAGE,
  payload: message,
});

export const clearMessages = () => ({
  type: CLEAR_MESSAGES,
  payload: undefined,
});
